var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox-input",class:{
    'disabled': _vm.disabled,
    'checked': _vm.value
  }},[_c('div',{staticClass:"click-area",on:{"click":function($event){$event.stopPropagation();return _vm.updateValue($event)}}},[_c('div',{staticClass:"control__indicator"}),_vm._v(" "),(_vm.text)?_c('label',{domProps:{"textContent":_vm._s(_vm.text)}}):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d0f9f5b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/pro4all-ui/sns-components/kit-components/input-templates/checkbox/CheckboxInput.vue
// module id = null
// module chunks = 